<template>
  <div class="section">
    <SubHeader :list="subCate" :baseRow="baseRow" @onChange="goSecondPage" v-if="baseRow && baseRow.id" />

    <div class="program-box flex jc" :class="{ 'noBorder': baseRow && baseRow.name == '小说' }">
      <template v-if="baseRow && baseRow.name == '小说'">
        <card-book :list="list" v-if="list && list.length > 0" />
        <Empty v-if="empty"></Empty>
      </template>
      <template v-else>
        <card-table :list="list" :category="baseRow.id" v-if="list && list.length > 0" />
        <Empty v-if="empty"></Empty>
      </template>
    </div>
  </div>
</template>

<script>
import SubHeader from "@/components/sub-header"
import CardBook from './CardBook.vue';
import CardTable from './CardTable.vue';
import { Empty } from "element-ui";
export default {
  name: 'item',
  props: {
    row: Object,
    path: String,
    colums: Array
  },
  components: { SubHeader, CardBook, CardTable, Empty },
  data() {
    return {
      baseRow: {},
      showpath: "",
      subCate: [],
      list: [],
      empty: false
    }
  },
  mounted() {
    this.baseRow = this.row || {};
    this.getSubCate();
    this.getList()
  },
  methods: {
    //获取子分类
    async getSubCate() {
      // let obj = this.colums.find(t => t.id == this.baseRow.id);
      // let params = {
      //   parentId: obj.labelid
      // };
      // console.log('this.route: ', this.$route)
      // let res = await this.$api.channelApi.getChannel(params);
      // this.subCate = res.data || [];
      
      this.subCate = this.row.children || []
    },
    // 跳转二级分类
    goSecondPage() {
      this.$emit("goSecondPage", this.baseRow);
    },
    async getList() {
      let res = await this.$api.literatureApi.getList({
        category: this.baseRow.id
      })
      let list = res.data || []
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_lfit,w_400`),
          };
        })
      );
      this.list = list.map(t => {
        if (t.type_id && !t.type_name) {
          let obj = this.subCate.find(v => { return v.id == t.type_id })
          obj && (t.type_name = obj.name)
        }
        return {
          ...t,
          author: this.$utils.fixedAuthor(t.listasv)
        }
      })
      if (this.list.length == 0) {
        this.empty = true
      } else {
        this.empty = false
      }
    }
  },
}
</script>
<style scoped lang="scss"></style>